import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { layers } from 'app/spacing';
import { CANVAS_PADDING } from './constants';

const checkerSize = 8;
const lightCheck = 'var(--color-background-white)';

export const pageBuilderBackgroundStyle = css`
  // CSS below defines a checkered background, plus a tint on top
  background-position:
    0px 0px,
    ${checkerSize}px ${checkerSize}px;
  background-size: ${2 * checkerSize}px ${2 * checkerSize}px;
  background-image: linear-gradient(
      to right,
      color-mix(in srgb, var(--color-background-black) 2%, transparent),
      color-mix(in srgb, var(--color-background-black) 2%, transparent)
    ),
    linear-gradient(
      45deg,
      var(--color-background-default) 25%,
      transparent 25%,
      transparent 75%,
      var(--color-background-default) 75%,
      var(--color-background-default) 100%
    ),
    linear-gradient(
      45deg,
      var(--color-background-default) 25%,
      ${lightCheck} 25%,
      ${lightCheck} 75%,
      var(--color-background-default) 75%,
      var(--color-background-default) 100%
    );
  padding: ${CANVAS_PADDING}px;
  padding-bottom: 50px;
`;

export const CanvasMeasureContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  ${({ showBoxShadow }) =>
    showBoxShadow &&
    css`
      background-color: color-mix(
        in srgb,
        var(--color-background-white) 50%,
        transparent
      );
    `}
  ${({ disabled }) =>
    // disable the page builer this way because we cannot update props on the editor
    // https://github.com/prevwong/craft.js/issues/149
    // disabling pointer events here (rather than higher up) allows for the builder to scroll while disabled
    disabled &&
    css`
      pointer-events: none;
    `}
  ${({ canResizeHeight = false }) =>
    canResizeHeight &&
    css`
      position: relative;
      align-items: center;
    `}
`;

// Ensure the gradients appear on top of the canvas content (the top one wasn't)
export const canvasScrollFadeContainerStyle = css`
  .gradient-vertical-container > :first-child,
  .gradient-vertical-container > :last-child {
    z-index: ${layers.content(1)};
  }
`;
